import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import { Tooltip, TooltipContent } from 'components/tooltip'
import themeTypes from 'helpers/enums/themes/themeTypes'

import styles from './tooltip.scss'

const MainTopbarTooltip = props => (
	<div styleName='tooltip'>
		<Tooltip theme={themeTypes.BLUE} arrow={props.arrow}>
			<TooltipContent mainText={props.title}/>
		</Tooltip>
	</div>
)

MainTopbarTooltip.defaultProps = {
	title: '',
	arrow: 'top-center',
}

MainTopbarTooltip.propTypes = {
	title: PropTypes.string,
	arrow: PropTypes.string,
}

export default CSSModules(MainTopbarTooltip, styles, {allowMultiple: true})
